import { render, staticRenderFns } from "./manage-plan.vue?vue&type=template&id=38d5c68f&scoped=true"
import script from "./manage-plan.vue?vue&type=script&lang=js"
export * from "./manage-plan.vue?vue&type=script&lang=js"
import style0 from "./manage-plan.vue?vue&type=style&index=0&id=38d5c68f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5c68f",
  null
  
)

export default component.exports